export type StreetType = 'STREET' | 'BUILDING';
export const StreetType = {
  STREET: 'STREET' as StreetType,
  BUILDING: 'BUILDING' as StreetType,
};
